export default __webpack_public_path__ + "static/media/past.726304f9.svg";